export type RinderpassScanProfil = 'ear_tag_only' | 'full';

const SCAN_PROFIL_TAG = '[scan:ear_tag_only]';

export function stripScanProfilTagFromBemerkung(bemerkung: string | null | undefined): string {
    if (!bemerkung) {
        return '';
    }
    let s = bemerkung.trim();
    if (s.startsWith(SCAN_PROFIL_TAG)) {
        s = s.slice(SCAN_PROFIL_TAG.length).trim();
    }
    return s;
}

export function parseRinderpassScanProfil(scan: RinderpassScan | null | undefined): RinderpassScanProfil {
    const profil = scan?.scan_profil;
    if (profil === 'ear_tag_only' || profil === 'full') {
        return profil;
    }
    const tag = scan?.bemerkung ?? '';
    return tag.includes(SCAN_PROFIL_TAG) ? 'ear_tag_only' : 'full';
}

export class RinderpassScan {
    grps_id: number;
    gruppe_id: number;
    bemerkung: string;
    /** ear_tag_only | full (vom Backend); Legacy-Scans ohne Feld: parseRinderpassScanProfil(). */
    scan_profil?: RinderpassScanProfil;
    gruppe: string;
    viehhaendler_id: number;
    viehhaendler: string;
    betriebskontakt_haendler_id: number;
    betriebskontakt: string;
    kp_einstalldatum: Date;
    pdf_id: number;
    seitenzahl_gesamt: number;
    seitenzahl_fehler: string;
    erstellt: Date;
    dateiname: string;
    verarbeitet_anzahl: number = undefined;
    /** Seiten mit erfolgreich=1 (verifizierte Ohrmarke). */
    ohrmarke_verifiziert_anzahl: number = undefined;
    einstall_tierliste_id?: number;
}
